/*
 * @Author: huangyan
 * @Date: 2021-11-05 11:15:29
 * @LastEditTime: 2022-03-03 14:54:45
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: /cloudoffice/assets/doclib/src/core/dataHandler.js
 */
import * as codeTable from './codeTable'

const getKBasePic = (picName) => {
  return './images/' + picName + '.png'
}

const getIcon = (type = '') => {
  type = type ? type.toLowerCase() : ''
  return codeTable.FileTypeMap[type] || 'default'
}

export default {
  getKBasePic,
  getIcon
}
